// 신청 근거 — 매물 링크 행 + 요청 스크린샷 스트립 (시안 A3 `listingRow`/`shotsRow`).
// request_photos 는 서버가 서명해서 내려준 배열이다(routes/eval-orders.js signRequestPhotos) — url 을 그대로 쓴다.
// props: { order, onToast }
import React, { useState } from 'react';
import { T, R, FONT } from '../../../theme';
import { useT } from '../../../../i18n/I18nProvider';
import { listingHost } from '../../fmt';
import LtrText from '../../parts/LtrText';
import Lightbox from './Lightbox';

var box = { background: T.card, border: '1px solid ' + T.bd, borderRadius: R.card, padding: '13px 14px' };
var head = { display: 'flex', alignItems: 'center', gap: 7, marginBottom: 9, fontSize: FONT.cardTitle, fontWeight: 800, color: T.ink };
var tag = { marginInlineStart: 'auto', fontSize: FONT.badge, fontWeight: 700, color: T.muted };
var urlRow = { display: 'flex', alignItems: 'center', gap: 9, minWidth: 0, flexWrap: 'wrap' };
var urlText = { flex: 1, minWidth: 0, fontSize: 11.5, color: T.accentPress, fontWeight: 700,
  overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' };
var smBtn = { height: 28, padding: '0 10px', borderRadius: R.sm, border: '1px solid ' + T.bd, background: T.card,
  color: T.body, fontSize: 11.5, fontWeight: 700, cursor: 'pointer', fontFamily: 'inherit',
  display: 'inline-flex', alignItems: 'center', textDecoration: 'none', flex: 'none' };
var openBtn = Object.assign({}, smBtn, { border: '1px solid ' + T.accentBd, background: T.accentTint, color: T.accentPress });
var strip = { display: 'flex', gap: 6, flexWrap: 'wrap' };
var shot = { width: 52, height: 52, borderRadius: R.sm, border: '1px solid ' + T.bd, background: T.head,
  objectFit: 'cover', cursor: 'pointer', display: 'block', flex: 'none', padding: 0 };

function RequestSource(props) {
  var t = useT();
  var o = props.order || {};
  var listing = String(o.listing_url || '').trim();
  var photos = Array.isArray(o.request_photos) ? o.request_photos : [];
  var st = useState(''); var big = st[0], setBig = st[1];
  var onToast = props.onToast;

  if (!listing && !photos.length) return null;

  // navigator.clipboard 는 https/localhost 에서만 있다 — 없으면 조용히 실패하지 않고 오류 문구를 띄운다.
  var copy = function () {
    var done = function () { if (onToast) onToast(t('inspListingCopied')); };
    var fail = function () { if (onToast) onToast(t('errorGeneric')); };
    if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(listing).then(done, fail);
    else fail();
  };

  return (<div className="ss-request-source" style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
    {listing ? (<div style={box}>
      <div style={head}>{t('inspListingSection')}</div>
      <div style={urlRow}>
        <LtrText style={urlText}>{listingHost(o) || listing}</LtrText>
        <a href={listing} target="_blank" rel="noopener noreferrer" style={openBtn}>{t('inspListingOpen')}</a>
        <button type="button" style={smBtn} onClick={copy}>{t('inspListingCopy')}</button>
      </div>
    </div>) : null}

    {photos.length ? (<div style={box}>
      <div style={head}>
        <span>{t('inspPhotoSection')}</span>
        <LtrText style={tag}>{t('inspPhotoCount', { count: photos.length })}</LtrText>
      </div>
      <div style={strip}>
        {photos.map(function (p, i) {
          return (<img key={p.filename || i} src={p.url} alt={t('inspPhotoSection')} style={shot}
            onClick={function () { setBig(p.url); }} />);
        })}
      </div>
    </div>) : null}

    <Lightbox src={big} alt={t('inspPhotoSection')} onClose={function () { setBig(''); }} />
  </div>);
}

export default RequestSource;
